import { render, staticRenderFns } from "./AddWechatAdvert.vue?vue&type=template&id=b352d85c&scoped=true"
import script from "./AddWechatAdvert.vue?vue&type=script&lang=js"
export * from "./AddWechatAdvert.vue?vue&type=script&lang=js"
import style0 from "./AddWechatAdvert.vue?vue&type=style&index=0&id=b352d85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b352d85c",
  null
  
)

export default component.exports